<div class="info" [ngStyle]="{'top':this.mouseY+'px', 'left':this.mouseY+'px'}">
</div>
